import { makeStyles } from '@mui/styles';

export const useUserDetailsPageHeaderStyles = makeStyles(() => ({
  root: {
    padding: '3rem 0',
    color: '#ffffff',
    position: 'relative',
    minHeight: '212px'
  },
  subtitle: {
    color: '#ffffffc4',
    fontSize: '1.175rem',
    minHeight: '1.85rem',
    marginBottom: '5px'
  },
  addressBox: {
    marginTop: '20px',
    '& p': {
      marginBottom: '1rem',
      lineHeight: 0.8
    }
  },
  actionButtonBox: {
    position: 'absolute',
    top: '3rem',
    right: 0
  },
  padLock: {
    position: 'absolute',
    right: 0,
    opacity: 0.5,
    top: '50%'
  },
  padLockMobile: {
    height: '20px',
    opacity: 0.5
  },
  managedUser: {
    textAlign: 'right',
    margin: 0
  },
  userName: {
    display: 'flex',
    flexDirection: 'row'
  },
  breadcrumbs: {
    color: '#ffffffc4',
    fontSize: '1rem',
    minHeight: '1.85rem',
    marginBottom: '5px'
  },
  breadcrumbSeparator: {
    margin: '0 0.5rem',
    opacity: 0.6
  },
  // Carrier logos vary wildly in aspect ratio, so cap the height and let the width follow
  // rather than letting a wide logo stretch the header past its 212px minimum.
  carrierImage: {
    maxHeight: '48px',
    maxWidth: '100%',
    objectFit: 'contain',
    marginTop: '0.5rem'
  },
  courierImage: {
    maxHeight: '96px',
    maxWidth: '100%',
    objectFit: 'contain',
    borderRadius: '4px',
    marginTop: '0.5rem'
  },
  info: {
    fontSize: '14px',
    marginBottom: '1rem'
  },
  marginBottomNull: {
    marginBottom: '0'
  },
  capabilities: {
    textTransform: 'uppercase',
    color: '#ffffffc4'
  },
  capabilitiesIcon: {
    height: 24,
    width: 24
  }
}));
